import { useState } from "react";
import { AuthLayout } from "../layouts/AuthLayout";
import { getApiBase } from "../../api/auth";
import "./LoginPage.css";

export function UnsubscribePage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState<{ type: "success" | "error"; text: string } | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(null);
    const trimmed = email.trim();
    if (!trimmed) {
      setMessage({ type: "error", text: "Veuillez entrer votre adresse courriel." });
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setMessage({ type: "error", text: "Adresse courriel invalide." });
      return;
    }
    setIsSubmitting(true);
    try {
      const res = await fetch(`${getApiBase()}/email/unsubscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: trimmed.toLowerCase() }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setMessage({
          type: "error",
          text: (data.detail as string) || "Une erreur est survenue. Veuillez réessayer.",
        });
        return;
      }
      setMessage({
        type: "success",
        text: "Votre désabonnement a bien été enregistré. Un courriel de confirmation vous a été envoyé.",
      });
      setEmail("");
    } catch {
      setMessage({ type: "error", text: "Impossible de contacter le serveur. Veuillez réessayer plus tard." });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthLayout>
      <div className="login-page">
        <div className="login-header">
          <div className="login-brand">XLFlow</div>
          <h1>Se désabonner</h1>
          <p>Entrez l'adresse courriel à désabonner de nos envois. Vous recevrez un courriel de confirmation.</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          <label htmlFor="unsubscribe-email" className="login-label">
            Adresse courriel
          </label>
          <input
            id="unsubscribe-email"
            type="email"
            className="login-input"
            placeholder="vous@exemple.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isSubmitting}
            autoComplete="email"
          />
          {message && (
            <div
              className="login-message"
              style={{
                color: message.type === "success" ? "var(--color-success, #059669)" : "var(--color-danger, #dc2626)",
              }}
            >
              {message.text}
            </div>
          )}
          <button type="submit" className="login-submit" disabled={isSubmitting}>
            {isSubmitting ? "Envoi en cours…" : "Confirmer le désabonnement"}
          </button>
        </form>
      </div>
    </AuthLayout>
  );
}
